import { legacyEntraIdInstaller } from "@p0security/integrations-azure-ad-frontend";
import {
  EntraIdComponents,
  EntraIdRegistration,
} from "@p0security/integrations-entra-id-shared";
import { Install, InstallProps } from "@p0security/integrations-installer";
import { useFlags } from "launchdarkly-react-client-sdk";

import { installSiblings } from "../installers";
import { LegacyAzureAd } from "./LegacyAzureAd";

export const EntraId = (
  props: Pick<
    InstallProps<typeof EntraIdComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const flags = useFlags();

  // Use feature flag to switch between legacy OAuth and new install framework
  const { entraInstallV2 } = flags;

  if (!entraInstallV2) {
    return <LegacyAzureAd />;
  }

  return (
    <Install<typeof EntraIdComponents>
      installer={legacyEntraIdInstaller}
      integration="azure-ad"
      registration={{ ...EntraIdRegistration, label: "Entra ID (Legacy)" }}
      siblings={installSiblings}
      {...props}
    />
  );
};
